import request from 'superagent';
import objectAssign from 'object-assign';

import { CUSTOMERS_URL } from 'constants/Jaws';

/**
 * Maps CLEARING_STATUS to a given string,
 * where CLEARING_STATUS is the index of
 * the array.
 */
export const clearingStatus = [
  'Uoppgjort',
  'Uoppgjort',
  'Ukjent',
  'Ukjent',
  'Ukjent',
  'Ukjent',
  'Kansellert',
  'Oppgjort',
  'Ukjent',
  'Ukjent',
];

/**
 * Used to fetch FULL_NAME where needed. Fetching FULL_NAME requires an extra
 * request against ProBroker, and it is therefore too expensive to do this
 * for every item in search, for example.
 */
export function getTransaction(
  customerNumber,
  customerId,
  orderId,
  transactionId,
) {
  return request
    .get(
      `${CUSTOMERS_URL}/${customerNumber}/orders/${orderId}/` +
        `transactions/${transactionId}`,
    )
    .query({ customerId });
}

export function execute(customerNumber, portfolioId, data) {
  return request
    .post(
      `${CUSTOMERS_URL}/${customerNumber}/depot/${portfolioId}/` +
        'transactions',
    )
    .send({ data });
}

export function getTransactionsByOrder(customerNumber, customerId, orderId) {
  return request
    .get(`${CUSTOMERS_URL}/${customerNumber}/orders/${orderId}/transactions`)
    .query({ customerId });
}

export function search(customerNumber, customerId, query) {
  /**
   * Valid query params:
   * ---
   *  - String customerId (Required)
   *  - String fromDate (Required)
   *  - String toDate (Required)
   *  - String orderId
   *  - String transactionId
   *  - String ticker
   *  - TradeType tradeType (BUY|SELL)
   */
  return request
    .get(`${CUSTOMERS_URL}/${customerNumber}/transactions/search`)
    .query(objectAssign({}, query, { customerId }));
}
